import React from 'react';
import { PlusCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { paths } from '@app/constants';
import { Namespace } from '@data';
import { AntdSpace, AntdTypography, Button } from '@ui/components';

const { Title, Text } = AntdTypography;

export const Header = () => {
  const { t } = useTranslation([Namespace.ADMIN]);

  return (
    <header
      style={{ borderBottom: '1px solid #F0F0F0' }}
      className="p-4 flex items-center justify-between"
    >
      <Title className="m-0 text-2xl font-medium">{t('trials_library.title')}</Title>
      {/* TODO: uncomment it later */}
      {/* {!IS_REVIEWER && (
        <AntdSpace className="ml-auto">
          <Text className="text-base-600">{t('trials_library.missing_something')}</Text>
          <Button
            role="link"
            type="primary"
            icon={<PlusCircleOutlined />}
            className="shadow-none rounded-[32px]"
          >
            {t('trials_library.request_new_trial')}
          </Button>
        </AntdSpace>
      )} */}
      <AntdSpace>
        <Text className="text-base-500">{t('trial_recruitment.missing_trial')}? </Text>
        <Link
          to={`/${paths.app}/${paths.trial_recruitment}/${paths.requests}`}
          state={{ openCreateTrialForm: true }}
        >
          <Button icon={<PlusCircleOutlined />} type="primary">
            {t('trial_recruitment.create_trial')}
          </Button>
        </Link>
      </AntdSpace>
    </header>
  );
};
